/**
 * List of saved payment methods. Renders `EmptySavedCards` when empty,
 * else maps each `SavedPaymentMethod` to `SavedCardItem`.
 */

import React from 'react';

import type { SavedPaymentMethod } from '../../../types/api';

import EmptySavedCards from './EmptySavedCards';
import SavedCardItem from './SavedCardItem';

export interface SavedCardListProps {
  items: SavedPaymentMethod[];
  onPayWithThis: (storedPaymentMethodId: string) => void;
  onAddCard: () => void;
}

const SavedCardList: React.FC<SavedCardListProps> = ({ items, onPayWithThis, onAddCard }) => {
  if (items.length === 0) return <EmptySavedCards onAddCard={onAddCard} />;
  return (
    <div role="list">
      {items.map((card) => (
        <SavedCardItem key={card.id} card={card} onPayWithThis={onPayWithThis} />
      ))}
    </div>
  );
};

export default SavedCardList;
